<template>

    <div class="user">
      <!--添加任务-->
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="发货单名称">
            <el-input placeholder="请输入发货单名称" v-model="formInline.search">
          
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          </el-form-item>
  
        </el-form>
      </div>

  
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        
              <el-table-column prop="order_num" label="订单号"></el-table-column>
              <el-table-column prop="driver.nickName" label="司机"></el-table-column>
              <el-table-column prop="driver.mobile" label="司机电话"></el-table-column>
              <el-table-column prop="storeCount" label="门店数量"></el-table-column>
              <el-table-column prop="storeCount" label="配送的门店" width="600">
                <template slot-scope="scope">
                    <div v-for="(item,index) in scope.row.store" :key="index" >
                      门店名称：<span style="font-size: 14px;font-weight: bold;">{{ item.store.store_name }}</span>
                   
                      <a>已打印次数：
                        <span style="color: crimson; font-size: 16px;font-weight: bold;">{{ item.is_print }}</span>
                      </a>

                      <a  @click="handlePreview( scope.row,item.store_id)"
                      style="color: blue;font-size: 15px;"
                      >预览打印</a>

                    </div>
                  
                </template>


              </el-table-column>
              <el-table-column prop="status" label="订单状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.status == 0">配送中</div>
                    <div v-if="scope.row.status == 1">已配送</div>
                </template>

              </el-table-column>
              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">

                  <el-button @click="editClick(scope.row)" type="text" size="small">详情</el-button>
                  <el-button @click="fkClick(scope.row)" type="text" size="small">反馈/凭证</el-button>
   
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      
      <Edit :open_add="open_edit" :ddelivery_id="ddelivery_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    </div>
  </template>
  
  <script>
    import DdeliveryApi from '@/api/ddelivery.js';
    import Edit from './gen_detail.vue';
import { concat } from 'lodash';
  
    export default {
      components: {
        Edit
      },
      inject: ['reload'],
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*搜索表单对象*/
          form: {},
          formInline: {
            search:""
          },
  
          open_add:false,
          open_edit:false,
          ddelivery_id:"",
          dialogVisible:false,
        };
      },
      created() {
  
        /*获取列表*/
        this.getTableList();
      },
      methods: {
         // 预览
        handlePreview(row,store_id) {

          let self = this;
          let Params = {};
          Params.id = row.ddelivery_id;
          Params.store_id = store_id;
          Params.page = 10;
          self.loading = true;
          DdeliveryApi.getListph(Params, true)
            .then(data => {
              var updatedTemplate = replaceTemplateValues( data);



              self.$lodop.previewTemp(updatedTemplate[0])
             
                self.loading = false;
            })
            .catch(error => {
            });

          //
        }
,
        printClick(item){
          this.$router.push({
            path: '/order/order/genorder',
            query: {
              id: item.ddelivery_id
            }
        });
        },
        fkClick(item){
          this.$router.push({
            path: '/plus/opinion/index',
            query: {
              id: item.ddelivery_id
            }
        });
        },
        dialogFormVisible(){
          this.dialogVisible = false;
        },
        setting(e){//发货单标题设置
          // this.categorya_id = e
          this.dialogVisible = true;
        },
         /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange(val) {
          this.curPage = val;
          this.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = this.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          self.loading = true;
          DdeliveryApi.list(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
  
        /*添加任务*/
        addClick() {
          this.open_add = true
        },
  
        /*编辑活动*/
        editClick(row) {
          this.ddelivery_id = row.ddelivery_id;
          this.open_edit = true
        },
  
        /*删除*/
        deleteClick(row) {
          let self = this;
          self
            .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              DdeliveryApi.del(
                {
                  ddelivery_id: row.ddelivery_id
                },
                true
              )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
            })
            .catch(() => {
            });
        }
      }
    };

    function   replaceTemplateValues(data) {
      var temps = [];
      var template = data.data.print;
      for(var x=0;x<data.data.list.length;x++){
        const orderData = data.data.list[x];
        const productData = orderData.data; 
          template.tempItems.forEach(item => {
     
          if (item.type === "braid-txt") {
              switch (item.title) {
                  case "单据日期":
                      item.value = item.value.replace("{单据日期:}", orderData.order_date);
                      break;
                  case "单据编号":
                      item.value = item.value.replace("{单据编号:}", orderData.order_code);
                      break;
                  case "下单客户":
                      item.value = item.value.replace("{客   户:}", orderData.customer_name);
                      break;
                  case "客户联系电话":
                      item.value = item.value.replace("{联系电话:}", orderData.phone);
                      break;
                  case "客户地址":
                      item.value = item.value.replace("{客户地址:}", orderData.address);
                      break;
                  case "公司地址":
                      item.value = item.value.replace("{公司地址:}", orderData.company_address);
                      break;
                  case "投诉与建议电话":
                      item.value = item.value.replace("{投诉与建议电话:}", orderData.complaint_phone);
                      break;
                  case "页码":
                      item.value = item.value.replace("{第几页/几页}", 

                      "第"+ (x+1)+"/"+ data.data.list.length +"页"

                      );
                      break;
                      
              }
          } else if (item.type === "braid-table") {
              // 动态生成表格数据
              const tableData = productData.map((product, index) => ({
                  rownum: index + 1, // 行号
                  product_name: product.product_name,
                  spec_value: product.spec_value,
                  product_code: product.product_code,
                  unit: product.unit,
                  set_num: product.set_num,
                  product_price: product.product_price,
                  amount: product.amount,
                  remarks: "" // 备注可以为空
              }));

              //加一行汇总
              tableData.push(
                {
                  rownum: '', // 行号
                  product_name:' 一联（白）回单；二联（红）客户',
                  spec_value: '',
                  product_code: '',
                  unit: '数量',
                  set_num: orderData.all_num,
                  product_price: '金额',
                  amount:orderData.all_price,
                  remarks: "" // 备注可以为空
              }

              );
              item.defaultValue = tableData; // 替换表格数据
             
          }
          if(item.title != '自定义文本'){
            item.value = item.title+":"+item.value
          }
         
          });
          temps.push(template)
    
      }
    return temps;
}
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/order/order/genindex.vue